import { useMutation, useQueryClient } from "@tanstack/react-query";
import queryKeys from "../constants/queryKeys";
import documentService from "../services/documentService";

const useAddAccountFile = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ formData, accountId, fileTypeHS, documentType }) =>
            documentService.uploadAccountFile(formData, accountId, fileTypeHS, documentType),
        onSuccess: () =>
            queryClient.invalidateQueries({ queryKey: [queryKeys.accountFiles] }),
    });
};

export default useAddAccountFile;
